import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import parse from "html-react-parser";
const HtmlRenderer = ({ html }) => {
    return _jsx("div", { children: parse(html) });
};
export default HtmlRenderer;
